import { apiUserPayGroups } from '~constants/api';
import { get } from '~libs/genericAction';
import { createThunks, Params } from '~libs/reduxUtils';

import { typePrefix as prefix } from '~care-workers/actions';

export const typePrefix = `${prefix}-pay-groups`;

const config = [
  {
    actionType: 'getAll',
    apiPath: apiUserPayGroups,
    method: get,
    actionParams: { attributes: ['id', 'name', 'company_id'], sort: ['name'], limit: 0 },
  },
  { actionType: 'getOne', apiPath: (params: Params) => `${apiUserPayGroups}/${params.id}`, method: get },
];

export const { getAll, getOne } = createThunks(typePrefix, config);
